<template>
    <div class="alert alert-warning" v-html="currentField.htmlContent"></div>
</div>
</template>

<script>
export default {
  name: 'NoticeComponent',
  props: ['currentField']
}
</script>
